import { render } from "./AddOrUpdateCommunity.vue?vue&type=template&id=2be751cc&scoped=true"
import script from "./AddOrUpdateCommunity.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateCommunity.vue?vue&type=script&lang=js"

import "./AddOrUpdateCommunity.vue?vue&type=style&index=0&id=2be751cc&lang=css"
import "./AddOrUpdateCommunity.vue?vue&type=style&index=1&id=2be751cc&scoped=true&lang=css"
import "./AddOrUpdateCommunity.vue?vue&type=style&index=2&id=2be751cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be751cc"]])

export default __exports__